import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import { colord } from "colord";

import { BALANCE_PRIVATE_MODE_SX } from "./balance-display.component";

type AdditionalBalanceDisplayProps = {
  totalBalanceColor: string;
  color: string;
  label: string;
  value: string;
  isPrivateMode?: boolean;
};
export default function AdditionalBalanceDisplay({
  totalBalanceColor,
  color,
  label,
  value,
  isPrivateMode
}: AdditionalBalanceDisplayProps) {
  const { palette } = useTheme();
  const contrastColor = colord(
    palette.getContrastText(colord(color).darken(0.05).toHex())
  )
    .alpha(0.2)
    .toHex();

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        mb: 0.5,
        px: 0.5,
        py: 0.1,
        background: color,
        borderRadius: "5px",
        border: `solid 1px ${contrastColor}`,
        boxShadow: "2px 2px 2px 0px rgba(0,0,0,0.15)"
      }}
    >
      <Box
        sx={{
          justifyContent: "flex-start",
          display: "flex",
          alignItems: "center",
          fontSize: `${label.length < 10 ? 14 : 12}px`,
          whiteSpace: "nowrap"
        }}
      >
        {label}
      </Box>
      <Typography
        fontSize="14px"
        data-testid="sale-balance-value"
        data-color={color}
        textAlign="right"
        width="100%"
        pl={1}
        sx={isPrivateMode ? BALANCE_PRIVATE_MODE_SX : {}}
      >
        {value}
      </Typography>
    </Stack>
  );
}
